function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import classnames from 'classnames';
var DIAMETER = 62;

var Circular = function Circular(props) {
  var _classnames;

  var prefixCls = props.prefixCls,
      className = props.className,
      size = props.size,
      percent = props.percent,
      strokeWidth = props.strokeWidth,
      loading = props.loading,
      style = props.style;
  var cls = classnames(className, prefixCls, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "--").concat(size), !!size), _defineProperty(_classnames, "".concat(prefixCls, "--circular"), loading), _classnames));
  var half = DIAMETER / 2;
  var r = half - strokeWidth / 2;
  var round = 2 * Math.PI * r;
  var lineStyle = {
    strokeDasharray: "".concat(round * percent / 100, " ").concat(round),
    strokeWidth: strokeWidth
  };

  if (loading) {
    return React.createElement("span", {
      className: cls,
      style: style
    }, React.createElement("svg", {
      viewBox: "".concat(DIAMETER / 2, " ").concat(DIAMETER / 2, " ").concat(DIAMETER, " ").concat(DIAMETER)
    }, React.createElement("circle", {
      cx: DIAMETER,
      cy: DIAMETER,
      r: r,
      fill: "none",
      style: {
        strokeWidth: strokeWidth
      }
    })));
  }

  return React.createElement("span", {
    className: cls,
    style: style
  }, React.createElement("svg", {
    viewBox: "0 0 ".concat(DIAMETER, " ").concat(DIAMETER)
  }, React.createElement("circle", {
    className: "".concat(prefixCls, "__path"),
    cx: half,
    cy: half,
    r: r,
    fill: "none",
    style: {
      strokeWidth: strokeWidth
    }
  }), React.createElement("circle", {
    className: "".concat(prefixCls, "__line"),
    cx: half,
    cy: half,
    r: r,
    fill: "none",
    style: lineStyle
  })));
};

var Spinner = function Spinner(props) {
  var prefixCls = props.prefixCls,
      className = props.className,
      size = props.size,
      style = props.style;
  var cls = classnames(prefixCls, "".concat(prefixCls, "--spinner"), className, _defineProperty({}, "".concat(prefixCls, "--").concat(size), !!size));
  var spinner = [];

  for (var i = 0; i < 12; i++) {
    spinner.push(React.createElement("div", {
      key: i
    }));
  }

  return React.createElement("div", {
    className: cls,
    style: style
  }, spinner);
};

var ActivityIndicator =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ActivityIndicator, _PureComponent);

  function ActivityIndicator() {
    _classCallCheck(this, ActivityIndicator);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActivityIndicator).apply(this, arguments));
  }

  _createClass(ActivityIndicator, [{
    key: "render",
    value: function render() {
      var type = this.props.type;
      return type !== 'spinner' ? React.createElement(Circular, this.props) : React.createElement(Spinner, this.props);
    }
  }]);

  return ActivityIndicator;
}(PureComponent);

ActivityIndicator.defaultProps = {
  prefixCls: 'za-activity-indicator',
  strokeWidth: 5,
  percent: 20,
  type: 'circular',
  loading: true
};
export { ActivityIndicator as default };